var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1776.48 2036.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{opacity:0.23;}.cls-3{fill:#4c0000;opacity:0;}.cls-4{fill:#4a0101;opacity:0.04;}.cls-5{fill:#480202;opacity:0.08;}.cls-6{fill:#460303;opacity:0.12;}.cls-7{fill:#440404;opacity:0.15;}.cls-8{fill:#420505;opacity:0.19;}.cls-9{fill:#400606;opacity:0.23;}.cls-10{fill:#3e0606;opacity:0.27;}.cls-11{fill:#3c0707;opacity:0.31;}.cls-12{fill:#3a0808;opacity:0.35;}.cls-13{fill:#380909;opacity:0.38;}.cls-14{fill:#360a0a;opacity:0.42;}.cls-15{fill:#340b0b;opacity:0.46;}.cls-16{fill:#330c0c;opacity:0.5;}.cls-17{fill:#310d0d;opacity:0.54;}.cls-18{fill:#2f0e0e;opacity:0.58;}.cls-19{fill:#2d0f0f;opacity:0.62;}.cls-20{fill:#2b1010;opacity:0.65;}.cls-21{fill:#291111;opacity:0.69;}.cls-22{fill:#271212;opacity:0.73;}.cls-23{fill:#251212;opacity:0.77;}.cls-24{fill:#231313;opacity:0.81;}.cls-25{fill:#211414;opacity:0.85;}.cls-26{fill:#1f1515;opacity:0.88;}.cls-27{fill:#1d1616;opacity:0.92;}.cls-28{fill:#1b1717;opacity:0.96;}.cls-29{fill:#191818;}.cls-30{fill:url(#linear-gradient);}.cls-31{fill:url(#linear-gradient-2);}.cls-32{fill:url(#linear-gradient-3);}.cls-33{fill:url(#linear-gradient-4);}.cls-34{fill:url(#linear-gradient-5);}.cls-35{fill:url(#linear-gradient-6);}.cls-36{fill:#d1cdce;}.cls-37{fill:url(#linear-gradient-7);}.cls-38{fill:url(#linear-gradient-8);}.cls-39{fill:url(#linear-gradient-9);}.cls-40{fill:url(#linear-gradient-10);}.cls-41{fill:url(#linear-gradient-11);}.cls-42{fill:url(#linear-gradient-12);}.cls-43{fill:url(#linear-gradient-13);}.cls-44{fill:url(#linear-gradient-14);}.cls-45{fill:url(#linear-gradient-15);}.cls-46{fill:url(#linear-gradient-16);}.cls-47{fill:url(#linear-gradient-17);}.cls-48{fill:url(#linear-gradient-18);}.cls-49{fill:#9a9a9a;}.cls-50{fill:url(#linear-gradient-19);}.cls-51{fill:url(#linear-gradient-20);}.cls-52{fill:url(#linear-gradient-21);}.cls-53{fill:url(#linear-gradient-22);}.cls-54{fill:url(#linear-gradient-23);}.cls-55{fill:#bebdbc;}.cls-56{fill:#767675;}.cls-57{fill:#b1b0af;}.cls-58{isolation:isolate;}.cls-59{clip-path:url(#clip-path);}.cls-60{fill:#737272;}.cls-61{fill:#a4a3a2;}.cls-62{clip-path:url(#clip-path-2);}.cls-63{fill:#969695;}.cls-64{fill:#929191;}.cls-65{fill:#8d8d8c;}.cls-66{fill:#898888;}.cls-67{clip-path:url(#clip-path-3);}.cls-68{fill:#9b9a99;}.cls-69{fill:#858483;}.cls-70{fill:#acacab;}.cls-71{fill:#9f9e9e;}.cls-72{fill:#dddcdb;}.cls-73{fill:#777;}.cls-74{fill:#969696;}.cls-75{fill:#858585;}.cls-76{fill:#4e4e4e;}.cls-77{fill:url(#linear-gradient-24);}.cls-78{fill:url(#linear-gradient-25);}.cls-79{fill:url(#linear-gradient-26);}.cls-80{fill:#fff;}.cls-81{fill:url(#linear-gradient-27);}.cls-82{fill:url(#linear-gradient-28);}.cls-83{fill:url(#linear-gradient-29);}.cls-84{fill:url(#linear-gradient-30);}.cls-85{fill:url(#linear-gradient-31);}.cls-86{fill:url(#linear-gradient-32);}.cls-87{fill:url(#linear-gradient-33);}.cls-88{fill:url(#linear-gradient-34);}.cls-89{fill:url(#linear-gradient-35);}.cls-90{fill:url(#linear-gradient-36);}.cls-91{fill:url(#linear-gradient-37);}.cls-92{fill:url(#linear-gradient-38);}.cls-93{fill:url(#linear-gradient-39);}.cls-94{fill:url(#linear-gradient-40);}.cls-95{fill:url(#linear-gradient-41);}.cls-96{fill:url(#linear-gradient-42);}.cls-97{fill:url(#linear-gradient-43);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 553.14,
    y1: 954.73,
    x2: 1348.08,
    y2: 954.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd2a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8952a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1217.42,
    y1: 1437.21,
    x2: 1348.08,
    y2: 1437.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 553.14,
    y1: 702.51,
    x2: 1387.01,
    y2: 702.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e6120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf8632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 505.77,
    y1: 492.31,
    x2: 1040.35,
    y2: 918.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9a9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 906.6,
    y1: 876.48,
    x2: 949.8,
    y2: 520.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1318.94,
    y1: 762.04,
    x2: 1285.85,
    y2: 1368.02,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1178.49,
    y1: 1260.84,
    x2: 1387.01,
    y2: 1260.84,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1176.43,
    y1: 897.01,
    x2: 467.2,
    y2: 1202.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1298.65,
    y1: 1041.79,
    x2: 886.2,
    y2: 902.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 823.32,
    y1: 782.54,
    x2: 883.92,
    y2: 782.54,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 911.84,
    y1: 739.64,
    x2: 474.78,
    y2: 497.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 188.28,
    y1: 809.1,
    x2: 289.47,
    y2: 809.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7f0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c65c14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 238.37,
    y1: 864.32,
    x2: 313.75,
    y2: 864.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7f0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 342.49,
    y1: 1090.34,
    x2: 214.87,
    y2: 796.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c664a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ba2b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 387.85,
    y1: 971.19,
    x2: 456.87,
    y2: 971.19,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 262.64,
    y1: 926.29,
    x2: 438.95,
    y2: 926.29,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 129.34,
    y1: 615.55,
    x2: 305.71,
    y2: 615.55,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 254.36,
    y1: 664.6,
    x2: 305.71,
    y2: 664.6,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 521.94,
    y1: 1103.45,
    x2: 452.74,
    y2: 866.58,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 300.19,
    y1: 722.6,
    x2: 543.88,
    y2: 722.6,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 458.65,
    y1: 794.29,
    x2: 543.88,
    y2: 794.29,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 297.68,
    y1: 1158.03,
    x2: 296.39,
    y2: 690.73,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 362.64,
    y1: 691.77,
    x2: 174.31,
    y2: 1318.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82fb7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ba2b3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1036.73,466.31,1092.36,434a65,65,0,0,0,13.75-10.73l-55.63,32.33A64.5,64.5,0,0,1,1036.73,466.31Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M903.48,109.11l-55.63,32.33a64.94,64.94,0,0,1,17.26-6.93l55.63-32.33A65.48,65.48,0,0,0,903.48,109.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1027.26,415.35,1082.88,383a64.5,64.5,0,0,0,11.27-21l-55.63,32.33A64.59,64.59,0,0,1,1027.26,415.35Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1000.81,
    y1: 1716.34,
    x2: 108.36,
    y2: 1492.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9a9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1000.81,
    y1: 1711.21,
    x2: 108.36,
    y2: 1487.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aeaeae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 1510.39,
    x2: 967.52,
    y2: 1510.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fafafa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 161.24,
    y1: 1362.2,
    x2: 290.58,
    y2: 1362.2,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 243.87,
    y1: 1410.45,
    x2: 373.21,
    y2: 1410.45,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 202.56,
    y1: 1386.33,
    x2: 331.9,
    y2: 1386.33,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 119.92,
    y1: 1338.08,
    x2: 249.26,
    y2: 1338.08,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 78.6,
    y1: 1313.96,
    x2: 207.94,
    y2: 1313.96,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 409.14,
    y1: 1506.93,
    x2: 538.48,
    y2: 1506.93,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 54.6,
    y1: 1291.7,
    x2: 165.1,
    y2: 1291.7,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 285.19,
    y1: 1434.57,
    x2: 414.53,
    y2: 1434.57,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 450.46,
    y1: 1531.83,
    x2: 582.45,
    y2: 1531.83,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 367.83,
    y1: 1482.81,
    x2: 497.17,
    y2: 1482.81,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 326.51,
    y1: 1458.69,
    x2: 455.85,
    y2: 1458.69,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 17715.73,
    y1: 1612.16,
    x2: 17637.41,
    y2: 1909.77,
    gradientTransform: "matrix(-1, -0.04, -0.05, 1.26, 19278.07, 229.6)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 17710.89,
    y1: 1610.88,
    x2: 17642.25,
    y2: 1871.7,
    gradientTransform: "matrix(-1, -0.04, -0.05, 1.26, 19278.07, 229.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 3067.08,
    y1: -15793.33,
    x2: 3044.41,
    y2: -15788.23,
    gradientTransform: "matrix(1.57, 1.56, 1.56, -1.57, 21145.03, -27657.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 10707.67,
    y1: 23110.44,
    x2: 10749.64,
    y2: 23110.44,
    gradientTransform: "matrix(-1.31, 0.04, 0.04, 1.31, 14272.47, -28902.26)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -7292.48,
    y1: 12020.75,
    x2: -7345.2,
    y2: 12035.67,
    gradientTransform: "matrix(-1.72, -1.39, -1.39, 1.72, 5199.59, -28959.55)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 5728.71,
    y1: 11379.37,
    x2: 5770.68,
    y2: 11379.37,
    gradientTransform: "matrix(-2.21, 0.07, 0.07, 2.21, 12922.66, -23595.46)",
    xlinkHref: "#linear-gradient-39"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 863.2,
    cy: 1413.57,
    rx: 157.52,
    ry: 300.51,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 863.2,
    cy: 1413.57,
    rx: 153.46,
    ry: 292.77,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 863.2,
    cy: 1413.57,
    rx: 149.4,
    ry: 285.03,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 863.2,
    cy: 1413.57,
    rx: 145.34,
    ry: 277.28,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 863.2,
    cy: 1413.57,
    rx: 141.29,
    ry: 269.54,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 863.2,
    cy: 1413.57,
    rx: 137.23,
    ry: 261.8,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 863.2,
    cy: 1413.57,
    rx: 133.17,
    ry: 254.06,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 863.2,
    cy: 1413.57,
    rx: 129.11,
    ry: 246.32,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 863.2,
    cy: 1413.57,
    rx: 125.06,
    ry: 238.58,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 863.2,
    cy: 1413.57,
    rx: 121,
    ry: 230.84,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 863.2,
    cy: 1413.57,
    rx: 116.94,
    ry: 223.1,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 863.2,
    cy: 1413.57,
    rx: 112.88,
    ry: 215.36,
    transform: "matrix(0, -1, 1, 0, -551.9, 2274.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 863.2,
    cy: 1413.57,
    rx: 108.83,
    ry: 207.62,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 863.2,
    cy: 1413.57,
    rx: 104.77,
    ry: 199.88,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 863.2,
    cy: 1413.57,
    rx: 100.71,
    ry: 192.14,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 863.2,
    cy: 1413.57,
    rx: 96.65,
    ry: 184.4,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 863.2,
    cy: 1413.57,
    rx: 92.6,
    ry: 176.65,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 863.2,
    cy: 1413.57,
    rx: 88.54,
    ry: 168.91,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 863.2,
    cy: 1413.57,
    rx: 84.48,
    ry: 161.17,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 863.2,
    cy: 1413.57,
    rx: 80.43,
    ry: 153.43,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 863.2,
    cy: 1413.57,
    rx: 76.37,
    ry: 145.69,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 863.2,
    cy: 1413.57,
    rx: 72.31,
    ry: 137.95,
    transform: "translate(-551.9 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 863.2,
    cy: 1413.57,
    rx: 68.25,
    ry: 130.21,
    transform: "translate(-551.91 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 863.2,
    cy: 1413.57,
    rx: 64.2,
    ry: 122.47,
    transform: "translate(-551.91 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 863.2,
    cy: 1413.57,
    rx: 60.14,
    ry: 114.73,
    transform: "translate(-551.91 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 863.2,
    cy: 1413.57,
    rx: 56.08,
    ry: 106.99,
    transform: "translate(-551.91 2274.26) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 863.21,
    cy: 1413.57,
    rx: 52.02,
    ry: 99.25,
    transform: "translate(-551.91 2274.25) rotate(-89.9)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 1475.98,
    cy: 1835.98,
    rx: 157.52,
    ry: 300.51,
    transform: "translate(-362.62 3308.7) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1475.98,
    cy: 1835.98,
    rx: 153.46,
    ry: 292.77,
    transform: "translate(-362.62 3308.7) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1475.98,
    cy: 1835.98,
    rx: 149.4,
    ry: 285.03,
    transform: "translate(-362.62 3308.7) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1475.98,
    cy: 1835.98,
    rx: 145.34,
    ry: 277.28,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1475.98,
    cy: 1835.98,
    rx: 141.29,
    ry: 269.54,
    transform: "translate(-362.62 3308.7) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1475.98,
    cy: 1835.98,
    rx: 137.23,
    ry: 261.8,
    transform: "translate(-362.62 3308.7) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1475.98,
    cy: 1835.98,
    rx: 133.17,
    ry: 254.06,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1475.98,
    cy: 1835.98,
    rx: 129.11,
    ry: 246.32,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1475.98,
    cy: 1835.98,
    rx: 125.06,
    ry: 238.58,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1475.98,
    cy: 1835.98,
    rx: 121,
    ry: 230.84,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 1475.98,
    cy: 1835.98,
    rx: 116.94,
    ry: 223.1,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 1475.98,
    cy: 1835.98,
    rx: 112.88,
    ry: 215.36,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1475.98,
    cy: 1835.98,
    rx: 108.83,
    ry: 207.62,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1475.98,
    cy: 1835.98,
    rx: 104.77,
    ry: 199.88,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1475.98,
    cy: 1835.98,
    rx: 100.71,
    ry: 192.14,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 1475.98,
    cy: 1835.98,
    rx: 96.65,
    ry: 184.4,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 1475.98,
    cy: 1835.98,
    rx: 92.6,
    ry: 176.65,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 1475.98,
    cy: 1835.98,
    rx: 88.54,
    ry: 168.91,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 1475.98,
    cy: 1835.98,
    rx: 84.48,
    ry: 161.17,
    transform: "matrix(0, -1, 1, 0, -362.62, 3308.69)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 1475.98,
    cy: 1835.98,
    rx: 80.43,
    ry: 153.43,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 1475.98,
    cy: 1835.98,
    rx: 76.37,
    ry: 145.69,
    transform: "translate(-362.62 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 1475.98,
    cy: 1835.98,
    rx: 72.31,
    ry: 137.95,
    transform: "translate(-362.63 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 1475.98,
    cy: 1835.98,
    rx: 68.25,
    ry: 130.21,
    transform: "translate(-362.63 3308.69) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 1475.98,
    cy: 1835.98,
    rx: 64.2,
    ry: 122.47,
    transform: "translate(-362.63 3308.68) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 1475.98,
    cy: 1835.98,
    rx: 60.14,
    ry: 114.73,
    transform: "translate(-362.63 3308.68) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 1475.98,
    cy: 1835.98,
    rx: 56.08,
    ry: 106.99,
    transform: "translate(-362.63 3308.68) rotate(-89.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 1475.98,
    cy: 1835.98,
    rx: 52.02,
    ry: 99.25,
    transform: "translate(-362.63 3308.68) rotate(-89.9)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 440.25,
    cy: 1627.09,
    rx: 157.52,
    ry: 455.43,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 440.25,
    cy: 1627.1,
    rx: 153.46,
    ry: 443.7,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 440.25,
    cy: 1627.1,
    rx: 149.4,
    ry: 431.97,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 440.25,
    cy: 1627.1,
    rx: 145.34,
    ry: 420.24,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 440.25,
    cy: 1627.1,
    rx: 141.29,
    ry: 408.5,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 440.25,
    cy: 1627.1,
    rx: 137.23,
    ry: 396.77,
    transform: "matrix(0.47, -0.88, 0.88, 0.47, -1204.69, 1259.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 440.25,
    cy: 1627.1,
    rx: 133.17,
    ry: 385.04,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 440.25,
    cy: 1627.1,
    rx: 129.11,
    ry: 373.31,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 440.25,
    cy: 1627.1,
    rx: 125.06,
    ry: 361.58,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 440.25,
    cy: 1627.1,
    rx: 121,
    ry: 349.85,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 440.25,
    cy: 1627.1,
    rx: 116.94,
    ry: 338.12,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 440.25,
    cy: 1627.1,
    rx: 112.88,
    ry: 326.38,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 440.25,
    cy: 1627.1,
    rx: 108.83,
    ry: 314.65,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 440.25,
    cy: 1627.1,
    rx: 104.77,
    ry: 302.92,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 440.25,
    cy: 1627.1,
    rx: 100.71,
    ry: 291.19,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 440.25,
    cy: 1627.1,
    rx: 96.65,
    ry: 279.46,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 440.25,
    cy: 1627.1,
    rx: 92.6,
    ry: 267.73,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 440.25,
    cy: 1627.1,
    rx: 88.54,
    ry: 256,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 440.25,
    cy: 1627.1,
    rx: 84.48,
    ry: 244.26,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 440.25,
    cy: 1627.1,
    rx: 80.42,
    ry: 232.53,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 440.25,
    cy: 1627.1,
    rx: 76.37,
    ry: 220.8,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 440.25,
    cy: 1627.1,
    rx: 72.31,
    ry: 209.07,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 440.26,
    cy: 1627.1,
    rx: 68.25,
    ry: 197.34,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 440.26,
    cy: 1627.1,
    rx: 64.19,
    ry: 185.61,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 440.26,
    cy: 1627.1,
    rx: 60.14,
    ry: 173.88,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 440.26,
    cy: 1627.1,
    rx: 56.08,
    ry: 162.14,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 440.26,
    cy: 1627.1,
    rx: 52.02,
    ry: 150.41,
    transform: "translate(-1204.69 1259.08) rotate(-62.25)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "553.14 470.71 1348.08 952.09 1348.08 1438.74 553.14 951.31 553.14 470.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "1348.08 1438.74 1217.41 1358.62 1217.41 1515.8 1348.08 1438.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "553.14 470.71 1348.08 952.09 1387.01 928.9 593 452.94 553.14 470.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "573.75 251.11 1321.3 703.78 1321.3 1444.66 573.75 985.93 533.84 271.37 573.75 251.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "533.84 271.37 1281.38 724.04 1281.38 1464.92 533.84 1006.19 533.84 271.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "1321.3 703.78 1281.38 724.04 1281.38 1464.92 1321.3 1444.66 1321.3 703.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1192.34,827.38,642.22,497.06c-6.85-4.11-12.45-13.08-12.45-19.92h0c0-6.85,5.6-9.09,12.45-5l550.12,330.32c6.85,4.11,12.45,13.08,12.45,19.93h0C1204.79,829.25,1199.19,831.49,1192.34,827.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1192.34,886.55,642.22,556.23c-6.85-4.11-12.45-13.08-12.45-19.93h0c0-6.84,5.6-9.08,12.45-5l550.12,330.32c6.85,4.11,12.45,13.08,12.45,19.93h0C1204.79,888.42,1199.19,890.66,1192.34,886.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1192.34,945.72,642.22,615.4c-6.85-4.11-12.45-13.08-12.45-19.93h0c0-6.84,5.6-9.08,12.45-5l550.12,330.32c6.85,4.11,12.45,13.08,12.45,19.93h0C1204.79,947.59,1199.19,949.83,1192.34,945.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1192.34,1004.89,642.22,674.57c-6.85-4.11-12.45-13.08-12.45-19.93h0c0-6.84,5.6-9.08,12.45-5L1192.34,980c6.85,4.11,12.45,13.08,12.45,19.93h0C1204.79,1006.76,1199.19,1009,1192.34,1004.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1192.34,1064.06,642.22,733.74c-6.85-4.11-12.45-13.08-12.45-19.93h0c0-6.84,5.6-9.08,12.45-5l550.12,330.32c6.85,4.11,12.45,13.08,12.45,19.93h0C1204.79,1065.93,1199.19,1068.17,1192.34,1064.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1076.67,1084.58,642.22,823.72c-6.85-4.12-12.45-13.08-12.45-19.93h0c0-6.85,5.6-9.09,12.45-5l434.45,260.86c6.85,4.11,12.45,13.08,12.45,19.93h0C1089.12,1086.46,1083.52,1088.69,1076.67,1084.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "1348.08 952.09 1348.08 1438.74 1217.41 1515.8 1217.41 1029.91 1178.49 1053.09 1178.49 1592.79 1387.01 1471.66 1387.01 928.9 1348.08 952.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "847.15 870.45 823.32 718.73 468.16 505.73 468.16 655.98 468.16 1190.82 1178.49 1592.79 1178.49 1057.95 847.15 870.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "1217.41 1029.91 883.92 844.67 847.15 870.45 1178.49 1057.95 1217.41 1029.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "823.32 718.73 863.2 694.62 883.92 844.67 847.15 870.45 823.32 718.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "468.16 505.73 823.32 718.73 863.2 694.62 506.17 486.77 468.16 505.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "188.28 818.97 239.39 789.27 289.48 799.22 238.37 828.92 188.28 818.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "238.37 828.92 289.48 799.22 313.75 899.72 262.64 929.42 238.37 828.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M399,1115.38c2-.93,4-1.94,5.87-3.05l51.1-29.7c-1.9,1.11-3.87,2.12-5.87,3-.65.31-1.34.57-2,.86-1.37.59-2.74,1.17-4.15,1.69-1.14.42-2.31.79-3.48,1.16-.7.21-1.39.46-2.1.66-1.46.41-2.95.76-4.45,1.09-.49.11-1,.24-1.45.34-1.86.38-3.75.68-5.65.94l-1.53.18c-1.75.2-3.51.36-5.29.46l-.54,0c-1.79.09-3.62.1-5.46.08-1.31,0-2.65-.06-4-.13-1.09,0-2.17-.09-3.27-.17s-2.25-.22-3.37-.35-2.48-.27-3.74-.45c-1.05-.15-2.11-.34-3.17-.52-1.34-.23-2.68-.47-4-.75-.92-.19-1.84-.4-2.76-.61-1.44-.34-2.9-.7-4.36-1.09-.91-.24-1.83-.49-2.75-.76-1.59-.46-3.19-1-4.79-1.48-.76-.25-1.51-.48-2.27-.75q-7.06-2.43-14.36-5.75c-.75-.34-1.5-.7-2.26-1.06-1.71-.81-3.42-1.64-5.15-2.52l-2.55-1.32c-2.28-1.21-4.57-2.44-6.88-3.77q-3.85-2.23-7.66-4.65l-.46-.28q-3.72-2.37-7.38-4.91c-.84-.57-1.66-1.18-2.5-1.77-1.63-1.16-3.26-2.33-4.88-3.54-1-.74-2-1.5-3-2.26-1.47-1.12-2.92-2.26-4.37-3.42-1.07-.85-2.12-1.72-3.18-2.59q-2.07-1.71-4.12-3.48c-1.09-.93-2.16-1.87-3.24-2.82q-2-1.79-4-3.62c-1.07-1-2.14-2-3.2-3-1.35-1.27-2.68-2.57-4-3.88-1-1-2-1.93-3-2.92-1.38-1.38-2.74-2.8-4.1-4.22-.9-.94-1.81-1.87-2.7-2.83-1.57-1.68-3.12-3.4-4.66-5.12-.63-.7-1.26-1.38-1.88-2.09q-3.27-3.71-6.44-7.51c-.34-.41-.67-.84-1-1.25-1.77-2.16-3.54-4.33-5.27-6.54q-3.36-4.28-6.59-8.66l-.1-.12c-3-4.15-6-8.4-8.91-12.7-.68-1-1.37-2-2-3-1-1.58-2.07-3.17-3.09-4.77-.91-1.43-1.83-2.86-2.73-4.3-1-1.61-2-3.24-2.95-4.86-.81-1.35-1.63-2.7-2.42-4.06q-3.49-6-6.78-12.09c-.8-1.49-1.58-3-2.36-4.51s-1.63-3.1-2.41-4.67c-1.15-2.28-2.26-4.57-3.36-6.87-.31-.66-.65-1.32-1-2q-2-4.35-4-8.73l-1-2.37q-1.39-3.24-2.73-6.49l-1.2-3q-1.26-3.15-2.44-6.32c-.34-.9-.68-1.79-1-2.68-1-2.78-2-5.56-2.93-8.34-.08-.23-.17-.46-.25-.7-1-3-2-6-2.88-9-.29-1-.56-1.94-.85-2.91q-.91-3.12-1.77-6.24c-.31-1.15-.61-2.3-.91-3.46-.5-1.94-1-3.87-1.45-5.81-.27-1.14-.54-2.29-.8-3.44-.45-2-.87-4-1.28-6-.21-1-.44-2.1-.64-3.15-.5-2.62-1-5.23-1.39-7.84-.06-.37-.13-.74-.19-1.1-.47-3-.88-5.94-1.25-8.9-.1-.84-.18-1.67-.28-2.51-.23-2.12-.45-4.23-.64-6.34-.09-1-.16-2-.24-3q-.22-3-.36-6c-.05-1-.1-1.92-.14-2.87-.1-2.82-.16-5.64-.16-8.43s.09-5.78.22-8.6c0-.83.1-1.64.15-2.47.11-1.92.24-3.82.41-5.69.09-1.06.21-2.09.32-3.13.17-1.61.36-3.21.57-4.78.17-1.18.34-2.35.53-3.51.23-1.43.47-2.85.73-4.24s.49-2.51.75-3.75.57-2.54.87-3.79.69-2.76,1.07-4.11c.31-1.12.62-2.23,1-3.32.51-1.69,1.07-3.34,1.64-5,.37-1,.72-2.11,1.11-3.13.2-.52.41-1,.62-1.55q1-2.54,2.12-5c.14-.31.28-.65.43-1q1.4-3,2.94-5.79l.07-.14c1.05-1.9,2.16-3.74,3.31-5.53.22-.34.45-.66.68-1q1.32-2,2.72-3.89c.37-.5.75-1,1.13-1.48q1.32-1.7,2.7-3.3c.35-.41.7-.83,1.06-1.23q1.89-2.13,3.91-4.1c.17-.17.36-.32.54-.49,1.18-1.13,2.4-2.22,3.64-3.26.44-.37.9-.73,1.35-1.09,1-.85,2.13-1.66,3.22-2.44.45-.33.89-.65,1.35-1,1.52-1.05,3.06-2.05,4.65-3h0l-51.1,29.7c-1.59.92-3.14,1.92-4.66,3-.45.31-.9.64-1.35,1-1.09.78-2.16,1.59-3.22,2.44-.45.36-.9.72-1.34,1.09-1.25,1-2.46,2.13-3.65,3.25-.17.17-.36.33-.54.5q-2,2-3.91,4.1c-.36.4-.7.82-1,1.23q-1.4,1.6-2.71,3.3c-.38.49-.75,1-1.12,1.48-.94,1.26-1.84,2.56-2.73,3.89-.22.34-.46.66-.68,1l-.19.29q-1.62,2.54-3.12,5.24l0,.1q-1.47,2.64-2.8,5.45c-.06.12-.11.25-.17.38-.14.31-.28.64-.43,1-.74,1.62-1.44,3.27-2.12,5-.2.51-.41,1-.61,1.54s-.32.8-.47,1.2c-.23.63-.42,1.3-.64,1.94-.57,1.63-1.13,3.28-1.65,5-.14.47-.31.91-.45,1.39s-.33,1.29-.51,1.93c-.37,1.35-.73,2.72-1.06,4.11-.15.61-.33,1.18-.47,1.8s-.26,1.34-.4,2c-.27,1.24-.52,2.48-.75,3.75-.13.65-.28,1.27-.39,1.93s-.22,1.54-.34,2.31c-.19,1.16-.37,2.32-.53,3.51-.08.6-.19,1.17-.26,1.78-.13,1-.21,2-.31,3s-.23,2.06-.33,3.11c0,.44-.09.86-.13,1.3-.12,1.44-.19,2.93-.27,4.41-.05.82-.12,1.63-.16,2.46,0,.2,0,.4,0,.6-.11,2.48-.17,5-.18,7.55v.45q0,3.52.1,7.08c0,.45,0,.9.06,1.35,0,.95.09,1.91.13,2.86.06,1.13.09,2.25.16,3.39.05.86.14,1.73.21,2.59s.15,2,.24,3c.06.67.09,1.33.16,2,.14,1.44.32,2.89.48,4.34.1.84.18,1.67.28,2.51l.09.84c.34,2.62.71,5.25,1.13,7.88l0,.18c.05.36.13.73.19,1.09.36,2.22.73,4.44,1.15,6.67.07.39.16.79.24,1.18.2,1.05.42,2.1.64,3.14.26,1.29.5,2.58.78,3.87.16.71.34,1.42.5,2.14.26,1.14.52,2.28.8,3.42.21.89.4,1.77.62,2.66.26,1.05.56,2.11.83,3.17s.59,2.3.91,3.45c.15.57.29,1.14.44,1.71.42,1.51.88,3,1.33,4.53.28,1,.55,1.94.85,2.91l.24.85c.83,2.7,1.7,5.41,2.61,8.11l0,.1c.07.21.15.43.23.65.81,2.42,1.65,4.83,2.52,7.25l.43,1.12c.33.9.67,1.8,1,2.7.48,1.29,1,2.58,1.45,3.86.32.82.66,1.63,1,2.45.39,1,.79,2,1.2,3,.29.73.58,1.46.88,2.19.6,1.44,1.22,2.87,1.84,4.3.34.79.67,1.58,1,2.37l.36.84c1.12,2.55,2.28,5.08,3.46,7.61,0,.09.09.18.14.28.31.66.64,1.32,1,2,.95,2,1.9,4,2.89,6l.46.89c.79,1.56,1.61,3.11,2.42,4.67.66,1.28,1.3,2.56,2,3.83.12.23.25.45.38.68q3.27,6.11,6.78,12.09c.2.34.38.69.58,1,.59,1,1.22,2,1.83,3,1,1.62,2,3.25,3,4.87q1.35,2.16,2.73,4.3c1,1.6,2,3.19,3.08,4.76.35.53.68,1.06,1,1.58s.7,1,1,1.47c2.9,4.29,5.85,8.54,8.91,12.69h0l.09.12q3.24,4.39,6.59,8.66c.11.12.2.25.3.38,1.64,2.08,3.3,4.12,5,6.16l1,1.24.06.08q3,3.6,6.06,7.1l.31.33c.63.72,1.27,1.41,1.9,2.11,1.3,1.45,2.58,2.91,3.9,4.32l.75.79c.89,1,1.8,1.89,2.71,2.84s2,2.09,3,3.1c.37.38.75.74,1.12,1.11,1,1,2,2,3,2.93s1.69,1.69,2.54,2.51c.48.46,1,.9,1.46,1.36l3.21,3c.74.69,1.48,1.4,2.23,2.07.58.53,1.18,1,1.77,1.55q1.6,1.42,3.24,2.82c.66.57,1.3,1.16,2,1.72s1.44,1.16,2.15,1.75c1.06.88,2.12,1.75,3.19,2.6.55.44,1.09.91,1.64,1.35.9.71,1.82,1.37,2.72,2.07s2,1.52,3,2.26l1.2.92c1.22.9,2.45,1.74,3.67,2.61.84.59,1.67,1.2,2.51,1.78l.65.46c2.2,1.52,4.43,3,6.66,4.41l.06,0,.48.3q3,1.92,6.1,3.74l1.55.89c1.66,1,3.33,1.9,5,2.8.63.34,1.25.64,1.88,1l2.55,1.33c.67.33,1.34.7,2,1,1.06.52,2.11,1,3.16,1.49.75.35,1.51.72,2.26,1.06l.93.44q3.16,1.41,6.28,2.66c2.13.86,4.24,1.65,6.33,2.39l.82.26c.76.27,1.51.5,2.26.74,1.07.35,2.15.73,3.21,1,.53.16,1.05.29,1.58.44.93.27,1.84.52,2.76.76.71.19,1.43.41,2.14.59s1.48.32,2.22.49c.92.22,1.84.43,2.75.62.49.1,1,.23,1.46.32.87.17,1.72.28,2.57.43,1.07.18,2.13.37,3.18.52l1.12.18c.88.12,1.74.17,2.61.27,1.13.12,2.26.26,3.38.34l1,.11c.77,0,1.51,0,2.27.07,1.34.06,2.67.12,4,.13.37,0,.75,0,1.12,0,1.46,0,2.9-.05,4.34-.12l.54,0c1.09-.06,2.18-.13,3.25-.23.69-.06,1.35-.16,2-.24q.76-.07,1.53-.18c1.85-.24,3.69-.53,5.49-.89l.16,0c.5-.1,1-.24,1.47-.35,1.49-.33,3-.67,4.43-1.08.71-.21,1.41-.45,2.12-.67.92-.29,1.87-.55,2.78-.88.23-.08.45-.19.68-.27,1.42-.52,2.79-1.1,4.16-1.7C397.67,1115.94,398.35,1115.69,399,1115.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "387.85 952.86 438.95 923.16 456.87 989.51 405.76 1019.21 387.85 952.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "262.64 929.42 313.75 899.72 438.95 923.16 387.85 952.86 262.64 929.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M141.3,632.24c.48-.2.95-.42,1.44-.62,1.95-.81,3.92-1.56,5.93-2.26,2.5-.87,5-1.67,7.61-2.37.41-.11.82-.19,1.22-.3,2.19-.57,4.41-1.1,6.66-1.56,1.67-.33,3.37-.62,5.08-.9.6-.09,1.2-.22,1.82-.3q3.56-.52,7.21-.84l1-.07q3-.24,6-.34c.72,0,1.45,0,2.18-.06,1.94,0,3.89,0,5.86,0,.41,0,.82,0,1.24,0,2.38.06,4.78.2,7.2.38l1.55.14c2.31.2,4.64.44,7,.75l.53.06,1.32.21c2.66.38,5.35.81,8.05,1.33,1.17.22,2.36.49,3.54.73,1.85.4,3.72.79,5.59,1.25,1.31.31,2.62.67,3.93,1,1.75.46,3.49.94,5.25,1.45,1.4.41,2.81.85,4.21,1.29q2.41.76,4.85,1.59c2.32.79,4.65,1.59,7,2.48l51.1-29.7q-2.54-1-5.06-1.85c-.65-.23-1.28-.41-1.92-.63-1.63-.55-3.24-1.07-4.85-1.58-.85-.27-1.71-.58-2.55-.84-.56-.17-1.1-.29-1.66-.46-1.76-.51-3.51-1-5.25-1.44-.88-.24-1.77-.52-2.64-.73-.44-.11-.86-.18-1.29-.29-1.88-.45-3.74-.85-5.6-1.24-.9-.19-1.82-.43-2.71-.61l-.82-.13c-2.71-.52-5.39-.95-8.05-1.33-.38-.05-.77-.14-1.15-.19l-.18,0-.53-.06c-2.35-.31-4.68-.55-7-.75l-1.54-.13-1.19-.11c-2-.14-4-.22-6-.28-.41,0-.82,0-1.23,0-1.22,0-2.44-.06-3.65,0-.75,0-1.48,0-2.22,0l-2.18.06q-3,.1-6,.34l-1,.07-.25,0c-2.35.21-4.66.49-7,.82-.61.09-1.21.21-1.82.31-1.49.23-3,.46-4.44.75-.22,0-.43.1-.64.15-2.25.45-4.46,1-6.64,1.55-.41.11-.83.19-1.23.3-2.58.7-5.12,1.5-7.61,2.37-.13.05-.26.08-.39.12-1.88.66-3.72,1.39-5.55,2.14l-1.42.62q-2.35,1-4.65,2.12l-1.63.8c-1.93,1-3.83,2-5.7,3.07l-51.1,29.69c1.86-1.08,3.77-2.09,5.69-3.06l1.64-.8Q139,633.25,141.3,632.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "254.61 635.31 305.71 605.61 305.46 693.89 254.36 723.59 254.61 635.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "414.81 875.65 465.92 845.95 427.7 887.66 376.6 917.36 414.81 875.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M576.74,1014.82c0-.65-.07-1.3-.09-2,0-1.4-.13-2.8-.2-4.2-.08-1.68-.13-3.35-.23-5-.08-1.27-.21-2.54-.3-3.8-.12-1.49-.23-3-.36-4.48-.09-1-.14-2-.24-3-.2-2.09-.46-4.2-.7-6.3-.14-1.27-.27-2.52-.42-3.79-.06-.43-.09-.85-.14-1.28q-.73-5.78-1.65-11.58c0-.08,0-.15,0-.23-.08-.52-.19-1.05-.27-1.57-.54-3.33-1.1-6.66-1.73-10-.1-.55-.23-1.11-.34-1.67-.29-1.52-.61-3-.92-4.56-.4-1.93-.76-3.86-1.18-5.8-.22-1-.49-2-.72-3.07-.38-1.71-.79-3.43-1.2-5.16-.32-1.33-.6-2.66-.93-4-.37-1.51-.79-3-1.18-4.52-.45-1.72-.89-3.44-1.36-5.16-.24-.88-.45-1.76-.69-2.64-.59-2.12-1.24-4.24-1.86-6.37-.45-1.51-.87-3-1.33-4.52-.14-.46-.26-.92-.4-1.39-1.16-3.77-2.38-7.55-3.63-11.32-.08-.22-.14-.45-.22-.68l0-.06q-2-5.9-4.11-11.78c-.17-.48-.36-.95-.54-1.43-.47-1.3-1-2.6-1.46-3.9-.76-2-1.5-4.06-2.29-6.08-.43-1.11-.89-2.22-1.33-3.33-.58-1.45-1.16-2.89-1.75-4.34-.47-1.16-.92-2.32-1.4-3.48-.83-2-1.7-4-2.55-6l-1.58-3.69c-.22-.48-.41-1-.62-1.45q-2.49-5.61-5.1-11.2l-.12-.25-.91-1.87c-1.54-3.26-3.1-6.51-4.71-9.74-.22-.44-.45-.87-.67-1.32-1.11-2.2-2.26-4.38-3.39-6.57-1-1.92-2-3.85-3-5.76-.22-.42-.46-.82-.68-1.24-2.75-5.12-5.55-10.22-8.46-15.26l-51.1,29.7c2.9,5,5.71,10.14,8.45,15.26,1.24,2.32,2.44,4.66,3.65,7s2.29,4.37,3.39,6.57q2.75,5.49,5.37,11c.3.64.62,1.28.92,1.92q3,6.42,5.84,12.89c.54,1.23,1.06,2.46,1.59,3.69q2,4.71,3.94,9.43c.59,1.44,1.18,2.89,1.75,4.35,1.25,3.13,2.45,6.26,3.63,9.41.48,1.29,1,2.58,1.46,3.88q2.43,6.63,4.67,13.28c.07.23.14.46.22.68q2.1,6.35,4,12.7c.46,1.51.88,3,1.32,4.54.88,3,1.74,6,2.56,9,.46,1.72.9,3.43,1.35,5.15.74,2.85,1.44,5.69,2.12,8.53.41,1.72.81,3.43,1.2,5.15.67,3,1.29,5.92,1.89,8.87.31,1.52.64,3,.93,4.56q1.13,5.85,2.06,11.66c.09.53.19,1.05.28,1.58q1,6.55,1.82,13.09c.16,1.26.28,2.52.43,3.78.35,3.11.67,6.21.94,9.3.13,1.49.24,3,.35,4.47q.33,4.44.54,8.84c.07,1.4.15,2.8.2,4.2.15,4.17.24,8.33.23,12.45,0,4.33-.13,8.57-.32,12.75-.05,1.19-.15,2.34-.21,3.51-.17,2.87-.36,5.71-.61,8.51-.15,1.62-.33,3.2-.5,4.79-.25,2.37-.53,4.72-.84,7-.24,1.71-.49,3.39-.76,5.06q-.51,3.19-1.09,6.31-.53,2.8-1.11,5.55c-.4,1.87-.83,3.72-1.27,5.55-.52,2.15-1.08,4.26-1.66,6.35s-1.2,4.36-1.87,6.48c-.16.51-.31,1-.48,1.53-1,3-2,5.9-3.11,8.75-.28.74-.58,1.47-.87,2.21q-1.5,3.75-3.15,7.35c-.21.47-.42,1-.64,1.42q-2.1,4.49-4.42,8.71l0,0q-2.32,4.21-4.87,8.15c-.34.53-.71,1-1.06,1.56-1.29,1.95-2.61,3.85-4,5.69-.55.74-1.11,1.47-1.67,2.2-1.3,1.67-2.64,3.3-4,4.89-.52.6-1,1.22-1.56,1.81-1.87,2.1-3.8,4.13-5.78,6.06-.28.27-.58.52-.86.78-1.73,1.66-3.51,3.24-5.33,4.77-.66.55-1.34,1.09-2,1.63-1.55,1.24-3.14,2.44-4.75,3.6-.67.48-1.33,1-2,1.43-2.24,1.54-4.53,3-6.88,4.39l51.1-29.7c2.36-1.37,4.64-2.85,6.89-4.39.68-.46,1.34-1,2-1.43,1.62-1.15,3.2-2.35,4.76-3.6.67-.54,1.34-1.07,2-1.63,1.82-1.53,3.6-3.11,5.34-4.77.28-.26.57-.51.85-.78,2-1.93,3.91-4,5.79-6.06.53-.59,1-1.21,1.55-1.81q2.05-2.38,4-4.89c.56-.73,1.12-1.45,1.67-2.19,1.37-1.85,2.7-3.76,4-5.71.35-.52.71-1,1.05-1.54l.31-.47a144.3,144.3,0,0,0,8.76-15.87c.09-.19.17-.39.26-.58.22-.46.42-1,.63-1.41,1.1-2.4,2.15-4.86,3.15-7.36.29-.73.59-1.46.88-2.21.21-.55.44-1.08.64-1.64.87-2.32,1.68-4.7,2.46-7.11.17-.5.32-1,.48-1.53.38-1.19.77-2.37,1.12-3.58.28-.94.49-1.94.76-2.89q.87-3.13,1.65-6.36c.21-.88.48-1.71.68-2.6s.38-2,.59-3q.59-2.74,1.11-5.55c.19-1,.41-1.88.58-2.85.19-1.13.33-2.32.52-3.46.26-1.67.52-3.35.75-5,.12-.87.27-1.71.39-2.58.18-1.46.3-3,.46-4.46s.35-3.17.49-4.79c.06-.65.15-1.27.2-1.93.18-2.15.28-4.38.41-6.58.07-1.17.16-2.32.22-3.51,0-.29,0-.57,0-.86q.23-5.52.26-11.22v-.67Q576.91,1020.1,576.74,1014.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "300.19 684.39 351.3 654.69 543.88 760.8 492.77 790.5 300.19 684.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "492.77 790.5 543.88 760.8 509.75 798.07 458.65 827.77 492.77 790.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "238.37 828.92 262.64 929.42 387.85 952.86 405.76 1019.21 234.24 992.09 188.28 818.97 238.37 828.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M254.61,635.31l-.25,88.28C186.94,705,137,746.66,136.78,830.43c-.28,99.61,69.74,220.92,156.43,271s157.16,9.86,157.44-89.74c.13-43.77-13.35-91.73-35.83-136L376.6,917.36l-76.41-233L492.77,790.5l-34.12,37.27C500.33,900.15,526,981.57,525.78,1055c-.42,147.29-104.66,206.69-232.82,132.7S61.24,934.35,61.65,787.06C62,655.41,145.37,594,254.61,635.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "843.2 224.56 898.82 192.23 866.06 173.32 810.43 205.64 843.2 224.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "968.06 469.23 1023.68 436.9 1023.79 398.75 968.17 431.08 968.06 469.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M890.13,286.7c-.12-.71-.23-1.43-.33-2.14,0-.34-.11-.68-.15-1,0-.14,0-.28,0-.42,0-.33-.07-.66-.11-1-.08-.69-.15-1.37-.21-2.05,0-.35-.06-.71-.08-1.06-.06-.69-.1-1.38-.13-2.06,0-.31,0-.62-.05-.93,0-1,0-2,0-2.92,0-16.81,6-28.63,15.54-34.19l55.63-32.32c-9.57,5.56-15.5,17.38-15.55,34.18,0,1,0,1.94.06,2.92,0,.32,0,.63.05.94,0,.68.07,1.37.12,2l.09,1.07c.06.67.13,1.35.2,2l.12,1c.06.48.13,1,.2,1.43.1.72.2,1.44.32,2.16.08.48.17,1,.26,1.44.13.7.26,1.4.4,2.09s.23,1.11.36,1.67.21.93.32,1.4.3,1.22.45,1.83l.36,1.38c.1.36.21.73.32,1.1.43,1.52.89,3,1.4,4.58,0,.12.07.24.11.36.5,1.49,1,3,1.59,4.44l.43,1.11c.49,1.25,1,2.49,1.53,3.73.08.19.15.38.24.57.59,1.38,1.22,2.74,1.87,4.1l.52,1.06c.53,1.08,1.07,2.15,1.63,3.21l.51,1c.72,1.34,1.45,2.66,2.21,4l.44.73c.67,1.14,1.36,2.26,2.06,3.38l.63,1q1.3,2,2.69,4l.43.59q1.44,2,3,4l.4.53c1.27,1.64,2.58,3.22,3.92,4.77l.53.62c.83.94,1.66,1.86,2.5,2.77l.15.16c.89.95,1.8,1.88,2.72,2.79.59.58,1.18,1.16,1.78,1.72l.47.45c.78.73,1.56,1.44,2.35,2.13l.65.55c.58.5,1.17,1,1.76,1.48.29.24.58.48.88.71l1.57,1.24,1,.71c.53.39,1,.77,1.58,1.14l.94.66c.57.39,1.15.77,1.72,1.14l.82.54c.84.53,1.7,1.05,2.55,1.55,1.14.65,2.26,1.25,3.38,1.81l1,.47c.86.41,1.7.8,2.54,1.16l.9.39c.79.32,1.58.62,2.36.9l.57.21c1,.33,1.93.62,2.88.88.56.16,1.11.29,1.66.42l.78.19c.81.17,1.61.32,2.41.44h.07c.73.11,1.46.2,2.17.27l.71.05c.52,0,1,.07,1.53.08h.68c.53,0,1.05,0,1.57,0l.55,0,.59-.05c.82-.06,1.62-.16,2.41-.28l.74-.13a26.31,26.31,0,0,0,2.66-.61l.12,0a25.31,25.31,0,0,0,2.4-.85l.68-.28c.67-.3,1.32-.62,2-1,.21-.11.43-.21.64-.33L980,368.83l-.29.16a3.78,3.78,0,0,1-.35.17c-.64.35-1.29.67-2,1-.12.06-.24.13-.37.18l-.31.11c-.78.32-1.58.6-2.4.85l-.1,0h0c-.86.25-1.76.44-2.66.61l-.31.07c-.14,0-.29,0-.43,0-.79.13-1.59.22-2.4.28l-.39.05h-.75c-.52,0-1,0-1.57,0h-1.21l-1-.08-.71-.05c-.72-.06-1.44-.15-2.17-.26h-.09q-1.18-.18-2.4-.45c-.26-.05-.52-.13-.78-.19l-1.51-.36-.14-.05c-.95-.26-1.91-.55-2.88-.89l-.57-.21c-.79-.28-1.57-.57-2.37-.9-.1,0-.21-.07-.31-.12l-.58-.26c-.84-.36-1.69-.75-2.54-1.16l-1-.47c-1.12-.57-2.25-1.16-3.38-1.82-.86-.49-1.71-1-2.56-1.55-.27-.17-.54-.36-.82-.53L937,361.89l-1-.67-1.57-1.13-1-.72c-.53-.4-1-.81-1.57-1.23l-.89-.71c-.59-.48-1.17-1-1.75-1.48l-.65-.55c-.8-.7-1.58-1.41-2.36-2.13l-.48-.46c-.52-.49-1-1-1.55-1.49l-.22-.23c-.92-.91-1.83-1.83-2.72-2.79l-.15-.16q-1.26-1.35-2.49-2.76l-.24-.26-.29-.36q-2-2.33-3.92-4.77l-.12-.14c-.1-.13-.19-.27-.29-.39-1-1.32-2-2.66-3-4-.09-.14-.2-.26-.29-.4a2.14,2.14,0,0,1-.13-.19c-.93-1.32-1.82-2.67-2.7-4l-.26-.39-.36-.59q-1.07-1.68-2.07-3.39c-.11-.18-.22-.35-.32-.53l-.12-.2q-1.14-2-2.2-4c-.06-.11-.13-.21-.18-.32s-.23-.45-.34-.67c-.56-1.06-1.1-2.13-1.62-3.2-.11-.22-.23-.44-.34-.67l-.18-.4c-.65-1.35-1.28-2.72-1.88-4.09l-.06-.13-.18-.45c-.53-1.24-1-2.48-1.53-3.73-.07-.2-.16-.4-.24-.6s-.12-.34-.18-.5c-.56-1.48-1.1-3-1.59-4.44l0-.09c0-.09-.05-.18-.08-.28-.5-1.52-1-3.05-1.4-4.58-.05-.19-.12-.38-.17-.57l-.14-.53c-.13-.46-.24-.92-.36-1.38-.16-.61-.31-1.22-.46-1.83s-.21-.93-.32-1.39-.15-.66-.22-1-.09-.46-.13-.69c-.15-.7-.28-1.39-.41-2.09C890.3,287.67,890.21,287.19,890.13,286.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1036.73,466.31,1092.36,434a65,65,0,0,0,13.75-10.73l-55.63,32.33a64.5,64.5,0,0,1-13.75,10.73"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "1050.48 455.58 1106.11 423.25 1082.88 383.02 1027.26 415.35 1050.48 455.58"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M865.11,134.51l55.63-32.33c-.93.23-1.85.48-2.76.74l-55.63,32.33c.91-.26,1.83-.51,2.76-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M862.35,135.25,918,102.92a67.23,67.23,0,0,0-7.07,2.5l-55.62,32.32a64.82,64.82,0,0,1,7.06-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M855.29,137.74l55.62-32.32a62.85,62.85,0,0,0-6.7,3.27L848.58,141a65,65,0,0,1,6.71-3.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M848.58,141l55.63-32.33-.73.42-55.63,32.33.73-.42"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "888.32 174.7 943.95 142.38 920.74 102.19 865.11 134.51 888.32 174.7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1027.26,415.35,1082.88,383a64.5,64.5,0,0,0,11.27-21l-55.63,32.33a64.59,64.59,0,0,1-11.26,21"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M913.3,176l-1.73-.39c-.91-.19-1.8-.34-2.69-.49l-1.54-.27-1.7-.21c-.72-.09-1.45-.19-2.16-.26l-1.71-.12c-.7-.05-1.4-.1-2.09-.12l-1.39,0c-.74,0-1.47,0-2.2,0-.48,0-1,0-1.45.05-.75,0-1.5.07-2.24.13l-.89.08c-1.08.1-2.14.22-3.19.38L944,142.38c1-.16,2.11-.29,3.18-.39l.9-.08,1-.08c.41,0,.82,0,1.23-.05l1.45-.05h2.19c.46,0,.93,0,1.39,0h.42c.55,0,1.12.08,1.68.12s1.13.06,1.7.12,1.44.16,2.16.25,1.13.13,1.7.22l.27,0c.42.06.85.16,1.27.23.89.16,1.79.31,2.69.49.58.12,1.16.27,1.74.4.85.19,1.7.39,2.56.62l.61.14c.94.26,1.88.53,2.83.82L919.3,177.53c-1.15-.35-2.3-.66-3.44-1C915,176.35,914.15,176.15,913.3,176Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1040.29,332.27q-.33-1.72-.69-3.45c-.13-.62-.27-1.24-.4-1.86-.26-1.18-.54-2.36-.82-3.54-.16-.65-.31-1.3-.48-1.95-.3-1.2-.61-2.39-.94-3.59-.16-.61-.33-1.22-.5-1.84-.27-1-.56-2-.85-2.92-.2-.68-.4-1.35-.61-2-.31-1-.65-2.07-1-3.1-.2-.61-.39-1.22-.59-1.83-.56-1.68-1.15-3.36-1.75-5l55.62-32.33q.92,2.51,1.75,5l.1.27c.17.52.33,1,.5,1.58q.51,1.54,1,3.09c.21.68.4,1.35.61,2,.28,1,.57,1.94.85,2.91.05.21.12.41.18.62.11.41.21.83.32,1.24.32,1.19.64,2.38.94,3.57l.48,1.95q.42,1.77.81,3.54c.09.41.2.82.28,1.23.05.21.08.42.13.63.24,1.16.47,2.31.69,3.47.1.55.21,1.1.31,1.65.31,1.7.59,3.39.85,5.09L1041.45,339c-.25-1.69-.54-3.39-.84-5.09C1040.51,333.38,1040.39,332.83,1040.29,332.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M991.6,230.77l-.07-.08c-1.25-1.53-2.52-3-3.8-4.5-.27-.32-.55-.63-.83-.95q-2-2.3-4.09-4.53c-.42-.45-.84-.91-1.27-1.36-1.63-1.72-3.27-3.42-4.93-5.07-.84-.83-1.7-1.64-2.55-2.45-.44-.42-.87-.86-1.31-1.27-1.31-1.22-2.62-2.42-4-3.6l55.63-32.33c1.32,1.18,2.64,2.38,3.94,3.6.45.42.89.86,1.34,1.29.82.78,1.64,1.56,2.46,2.36l.06.07c1.67,1.65,3.31,3.35,4.94,5.07l1.27,1.37c1.38,1.49,2.74,3,4.08,4.53.2.22.41.44.61.67l.23.27q1.91,2.2,3.77,4.47l.1.11c1.27,1.55,2.52,3.13,3.76,4.72l.21.27q1.5,1.94,3,3.9l-55.63,32.33q-1.57-2.11-3.18-4.18Q993.5,233.09,991.6,230.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "1074.23 357.94 1129.85 325.62 1097.08 306.7 1041.45 339.02 1074.23 357.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1075.56,380.84a193.93,193.93,0,0,0-1.33-22.9l55.62-32.32a191.58,191.58,0,0,1,1.33,22.9,154.48,154.48,0,0,1-2,25.19c-.44,2.6-.94,5.14-1.51,7.6L1072,413.64A147.45,147.45,0,0,0,1075.56,380.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "968.8 206.96 1024.43 174.63 1024.54 136.51 968.91 168.84 968.8 206.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M935.58,146.85c-1.25-.64-2.5-1.27-3.74-1.88l-1.88-.89c-1.23-.57-2.46-1.12-3.68-1.65-.56-.25-1.12-.5-1.67-.73-1.75-.73-3.48-1.43-5.2-2.07L975,107.3q2.25.84,4.51,1.78l.69.29,1.68.73c1.22.53,2.45,1.08,3.68,1.66l1.87.89c1.24.6,2.49,1.23,3.75,1.88.56.29,1.12.57,1.68.87,1.8.95,3.61,1.94,5.43,3a204.72,204.72,0,0,1,26.22,18.11l-55.63,32.33a205.73,205.73,0,0,0-26.21-18.12c-1.82-1.05-3.63-2-5.43-3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "1021.82 226.41 1077.44 194.08 1054.16 207.34 998.54 239.66 1021.82 226.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1051.5,278.64q-1.38-3.06-2.83-6.1c-.16-.34-.31-.68-.48-1-1.12-2.33-2.28-4.65-3.46-7-.32-.63-.64-1.24-1-1.86-.93-1.78-1.87-3.56-2.83-5.32l-1-1.94c-1.27-2.28-2.55-4.56-3.86-6.81l-.38-.64c-1.22-2.06-2.45-4.11-3.71-6.15l-1.27-2c-1-1.64-2.07-3.26-3.12-4.88-.44-.66-.87-1.32-1.3-2-1.46-2.2-2.93-4.38-4.43-6.53l55.62-32.33q2.25,3.24,4.43,6.53c.44.66.87,1.33,1.3,2,.56.85,1.12,1.69,1.67,2.55s1,1.55,1.45,2.32l1.28,2.05c1.25,2,2.49,4.08,3.7,6.15.13.21.26.42.38.63l.08.13q1.93,3.31,3.78,6.68c.36.65.7,1.3,1.06,1.94.46.86.94,1.72,1.4,2.58s1,1.83,1.42,2.74l1,1.86c1.13,2.22,2.25,4.44,3.33,6.68,0,.09.08.19.13.28l.48,1c1,2,1.91,4.07,2.83,6.11l.93,2.08c.29.67.59,1.32.88,2q1.05,2.44,2.07,4.89h0l-55.62,32.33c-1-2.3-2-4.6-3-6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M809,226.93a154,154,0,0,1,1.46-21.29l32.77,18.92c2.09-11.08,5.85-20.48,11-28.08l-23.46-40.63a64.58,64.58,0,0,1,34.36-21.34l23.21,40.19c9.4-1.45,19.84-.57,31,2.83l.11-37.9a154.66,154.66,0,0,1,23.29,11.09,205.73,205.73,0,0,1,26.21,18.12L968.8,207a215,215,0,0,1,29.74,32.7l23.28-13.25a322.51,322.51,0,0,1,33.57,61.2l-23.72,13.52a198.12,198.12,0,0,1,9.78,37.89l32.78,18.92a193.93,193.93,0,0,1,1.33,22.9,147.45,147.45,0,0,1-3.55,32.8l-33.49-19.33a64.59,64.59,0,0,1-11.26,21l23.22,40.23a64.64,64.64,0,0,1-35.89,18.66l-23.45-40.63a70.66,70.66,0,0,1-23-2.53l-.11,38.15a154,154,0,0,1-26.23-12.18,202.54,202.54,0,0,1-23.28-15.78l.11-37.93a203.67,203.67,0,0,1-23.95-24.19L871,392.66A324.53,324.53,0,0,1,834.78,333l23.28-13.26A215.89,215.89,0,0,1,845.81,283l-33.48-19.33A205.64,205.64,0,0,1,809,226.93ZM942.09,365.11c29.43,17,53.36,3.35,53.45-30.46s-23.68-75-53.1-92-53.38-3.36-53.47,30.47,23.69,75,53.12,92"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "714.39 179.27 745.18 161.38 744.84 281.73 714.05 299.62 714.39 179.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "671.52 17.89 702.31 0 788.66 186.48 757.87 204.37 671.52 17.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "671.52 17.89 757.87 204.37 714.39 179.27 714.05 299.62 627.74 249.79 628.08 129.43 584.62 104.34 671.52 17.89"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "1166.56 443.43 1197.34 425.54 1240.82 450.64 1210.03 468.54 1166.56 443.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "1296.33 518.36 1327.12 500.47 1370.6 525.57 1339.81 543.46 1296.33 518.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "1339.81 543.46 1370.6 525.57 1283.68 612.03 1252.89 629.92 1339.81 543.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "1296.67 398.01 1327.46 380.11 1327.12 500.47 1296.33 518.36 1296.67 398.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "1210.37 348.18 1241.16 330.29 1327.46 380.11 1296.67 398.01 1210.37 348.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "1296.67 398.01 1296.33 518.36 1339.81 543.46 1252.89 629.92 1166.56 443.43 1210.03 468.54 1210.37 348.18 1296.67 398.01"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M966.41,1787v-55.5L728.94,1622.85,195.65,1311.51a158.48,158.48,0,0,0-154-3.21L1.42,1289.89v69.81c-5.67,28.61,5.82,60.14,34.5,76.88L756.21,1857.1a173.5,173.5,0,0,0,174.76.1l4.65-2.71C960.83,1839.81,971.1,1812.23,966.41,1787Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M966.41,1781.91v-55.5L728.94,1617.73,195.65,1306.38a158.48,158.48,0,0,0-154-3.21L1.42,1284.76v69.81c-5.67,28.61,5.82,60.14,34.5,76.88L756.21,1852a173.48,173.48,0,0,0,174.76.1l4.65-2.7C960.83,1834.68,971.1,1807.1,966.41,1781.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M195.65,1236.57l740,432c42.48,24.8,42.44,86.19-.06,111l-4.64,2.7a173.52,173.52,0,0,1-174.77-.1L35.92,1361.64c-47.92-28-47.88-97.24.07-125.16h0A158.49,158.49,0,0,1,195.65,1236.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M843.68,1777a144.78,144.78,0,0,1-72.93-19.73L50.45,1336.75a43.61,43.61,0,0,1,0-75.36,129.69,129.69,0,0,1,130.62.07l740,432a35.39,35.39,0,0,1,0,61.15l-4.63,2.69A144.85,144.85,0,0,1,843.68,1777Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "290.58 1336.99 270.23 1325.11 161.24 1387.42 181.59 1399.3 290.58 1336.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "373.21 1385.23 352.87 1373.36 243.87 1435.66 264.22 1447.54 373.21 1385.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "331.9 1361.11 311.55 1349.23 202.56 1411.54 222.9 1423.42 331.9 1361.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "249.26 1312.87 228.91 1300.99 119.92 1363.29 140.27 1375.17 249.26 1312.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "98.95 1351.05 207.94 1288.75 187.6 1276.87 78.6 1339.17 98.95 1351.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "538.48 1481.72 518.13 1469.84 409.14 1532.15 429.49 1544.03 538.48 1481.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M165.1,1265.5A107.3,107.3,0,0,0,72.61,1273,36.31,36.31,0,0,0,61,1325Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "414.53 1409.36 394.18 1397.48 285.19 1459.78 305.54 1471.66 414.53 1409.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "450.46 1556.27 473.46 1569.7 582.45 1507.39 559.45 1493.96 450.46 1556.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "497.17 1457.6 476.82 1445.72 367.83 1508.02 388.17 1519.9 497.17 1457.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "455.85 1433.48 435.5 1421.6 326.51 1483.9 346.86 1495.78 455.85 1433.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1287.5,1681.72q-.16,4.15,0,8.27-.49,4.1-.68,8.25c-.11,2.77-.12,5.52,0,8.27q-.49,4.08-.68,8.24c-3.67,86.79,99.11,161.62,229.57,167.15s239.2-60.35,242.87-147.13q.18-4.15,0-8.28c.33-2.72.56-5.47.67-8.24s.13-5.53,0-8.27c.33-2.73.56-5.48.67-8.25s.13-5.53,0-8.27c.33-2.73.55-5.47.67-8.24,3.68-86.79-99.1-161.62-229.56-167.15s-239.2,60.35-242.88,147.13q-.17,4.15,0,8.28Q1287.69,1677.56,1287.5,1681.72Zm47.1,10.27c19.84-58.09,99.63-99.17,193.14-95.21s169.55,51.64,184.41,111.2c-19.84,58.09-99.64,99.17-193.15,95.21S1349.45,1751.55,1334.6,1692Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1288.2,1665.2c-3.67,86.79,99.11,161.62,229.57,167.15S1757,1772,1760.64,1685.22s-99.1-161.62-229.56-167.15S1291.88,1578.42,1288.2,1665.2Zm43.83,1.86c3-70.68,91.56-124.33,197.81-119.83s190,65.45,187,136.13-91.55,124.33-197.81,119.83S1329,1737.74,1332,1667.06Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M1223.79,1900.91c-.08-.65-.18-1.31-.3-2s-.29-1.45-.45-2.19c-.11-.49-.21-1-.34-1.49s-.26-.93-.39-1.39c-.19-.65-.38-1.3-.59-1.95l-.39-1.12c-.25-.73-.52-1.46-.81-2.18l-.35-.9c-.42-1-.85-2-1.32-3l-.17-.34c-.43-.88-.88-1.76-1.34-2.63l-.45-.81c-.46-.82-.93-1.63-1.42-2.43l-.28-.47q-.89-1.41-1.83-2.76l-.56-.78c-.47-.65-.94-1.29-1.43-1.92-.26-.34-.53-.68-.8-1-.42-.53-.86-1-1.29-1.55l-1.11-1.26c-.36-.4-.73-.77-1.09-1.16-.63-.65-1.26-1.28-1.9-1.89-.4-.38-.8-.76-1.21-1.13l-1-.84c-.53-.45-1.07-.88-1.6-1.31l-1-.74c-.59-.44-1.18-.85-1.78-1.25l-.85-.58c-.88-.56-1.78-1.1-2.68-1.58s-1.72-.86-2.57-1.23l-.66-.27c-.47-.19-.92-.34-1.38-.5-.67-.23-1.32-.44-2-.61-.41-.11-.83-.22-1.23-.3s-.76-.15-1.14-.2-1-.14-1.46-.18l-.83,0a14.86,14.86,0,0,0-1.77,0c-.13,0-.27,0-.41,0a14.67,14.67,0,0,0-2,.32l-.48.13a12,12,0,0,0-1.5.49,3.66,3.66,0,0,0-.46.18,12.42,12.42,0,0,0-1.78.91L1319,1767.74l.15-.1c.44-.26.89-.5,1.36-.72l.27-.1c.15-.07.31-.12.46-.18s.47-.2.71-.28.53-.14.79-.21l.48-.13.26-.07c.54-.11,1.09-.19,1.66-.25h.11l.4,0c.43,0,.87-.06,1.31,0l.46,0,.83,0c.26,0,.51,0,.77.06s.47.08.69.12c.38.06.76.12,1.14.2.21.05.4.06.61.11s.42.14.63.19c.64.18,1.29.38,2,.61.23.08.46.12.69.21l.69.29.66.28c.85.36,1.7.76,2.57,1.22s1.8,1,2.68,1.59c.29.18.57.38.85.57.6.4,1.2.81,1.78,1.25.33.24.65.49,1,.75.54.42,1.07.85,1.6,1.3l1,.84c.2.18.41.35.6.53s.4.41.61.6c.64.62,1.28,1.25,1.9,1.9.2.21.41.39.61.6l.48.55c.37.41.74.84,1.11,1.27.24.28.49.54.73.83s.38.48.57.71l.79,1c.18.24.38.46.55.7.31.4.59.81.88,1.22l.56.78.24.33c.51.75,1,1.51,1.49,2.28l.1.15c.1.16.19.32.28.48.34.54.67,1.09,1,1.64.15.26.29.52.43.79s.3.53.45.81l.39.7c.33.64.64,1.28,1,1.92l.17.34.05.09c.38.81.74,1.62,1.09,2.44l.18.45c.12.3.24.6.35.9s.34.81.49,1.22.21.64.33,1,.26.75.38,1.12l.24.69c.13.42.23.84.35,1.26s.27.93.39,1.4c0,.16.1.32.14.48.08.34.13.67.2,1q.26,1.1.45,2.19c0,.2.09.4.13.6.07.46.12.91.18,1.37s.09.65.13,1c.11,1,.19,2,.22,3,.26,8.68-2.6,14.9-7.45,17.93l-143.49,89.3c4.85-3,7.72-9.25,7.46-17.93,0-1-.12-2-.23-3C1223.89,1901.57,1223.84,1901.24,1223.79,1900.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1195.13,1858.3c-15.49-8.27-27.64-.82-27.11,16.66s13.53,38.36,29,46.63,27.63.81,27.11-16.66S1210.63,1866.58,1195.13,1858.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1091.5,1995.73c-.15-1.1-.32-2.21-.51-3.32s-.49-2.45-.76-3.69c-.19-.83-.37-1.67-.58-2.51s-.44-1.56-.66-2.35c-.31-1.09-.63-2.18-1-3.27-.21-.64-.43-1.27-.65-1.9-.43-1.22-.88-2.45-1.37-3.67-.19-.5-.39-1-.59-1.51-.7-1.68-1.43-3.36-2.22-5-.09-.19-.19-.38-.29-.57-.71-1.49-1.47-3-2.26-4.43l-.75-1.36q-1.15-2.07-2.4-4.1l-.47-.79q-1.49-2.37-3.08-4.65l-.94-1.32c-.79-1.09-1.59-2.17-2.41-3.22-.44-.58-.89-1.15-1.34-1.71-.72-.89-1.45-1.75-2.18-2.6s-1.24-1.44-1.88-2.14-1.21-1.3-1.83-1.94c-1-1.09-2.11-2.16-3.2-3.19-.67-.64-1.35-1.29-2-1.9s-1.08-1-1.62-1.41c-.89-.76-1.8-1.49-2.7-2.21-.54-.42-1.08-.85-1.63-1.25-1-.74-2-1.43-3-2.11-.47-.32-.94-.66-1.43-1-1.49-.95-3-1.85-4.52-2.66s-2.9-1.45-4.32-2.07l-1.11-.46c-.79-.32-1.56-.58-2.34-.85-1.11-.38-2.21-.73-3.3-1-.7-.19-1.39-.37-2.08-.51s-1.28-.25-1.91-.34c-.84-.13-1.66-.24-2.47-.3-.47,0-.94-.08-1.4-.09a26.81,26.81,0,0,0-3,0c-.22,0-.45,0-.68,0a26.65,26.65,0,0,0-3.41.55c-.28.06-.54.14-.81.22a21.35,21.35,0,0,0-2.53.82c-.26.1-.52.19-.77.3a22.91,22.91,0,0,0-3,1.54l172.35-105,.25-.16a22.77,22.77,0,0,1,2.29-1.21c.15-.07.31-.11.46-.18s.52-.2.78-.3.78-.34,1.19-.47.88-.24,1.33-.35c.27-.07.54-.16.81-.22s.29-.08.44-.12q1.37-.27,2.79-.42h.18l.68,0c.73,0,1.46-.1,2.21-.09.25,0,.52,0,.77,0,.46,0,.93,0,1.4.09s.86,0,1.3.09.78.15,1.17.21c.63.09,1.27.21,1.91.34.35.07.68.1,1,.19s.71.23,1,.32c1.09.29,2.19.63,3.31,1,.39.13.77.21,1.17.36s.77.32,1.16.48.74.3,1.11.47c1.43.61,2.86,1.28,4.33,2.06s3,1.71,4.52,2.67c.48.3,1,.64,1.43,1,1,.67,2,1.36,3,2.1.55.4,1.09.83,1.63,1.26.91.71,1.81,1.44,2.7,2.2q.81.69,1.62,1.41c.33.3.68.58,1,.89s.67.68,1,1c1.09,1,2.15,2.1,3.21,3.2.33.35.69.66,1,1s.53.61.8.91c.64.7,1.26,1.42,1.88,2.14.4.47.83.92,1.23,1.4s.63.81.95,1.21c.45.56.9,1.12,1.34,1.69.31.4.63.78.93,1.18.51.67,1,1.37,1.48,2.06.31.43.64.87.94,1.31.13.19.27.36.4.55.86,1.26,1.71,2.54,2.52,3.84l.16.26.48.8c.56.92,1.13,1.84,1.67,2.77.25.44.48.88.72,1.32l.75,1.36c.21.4.44.79.65,1.19.56,1.07,1.09,2.16,1.61,3.24.1.19.2.38.29.57l.08.16c.64,1.35,1.25,2.72,1.83,4.1.11.25.2.51.31.76.21.51.4,1,.6,1.51.27.69.55,1.36.81,2,.2.54.36,1.08.55,1.62s.44,1.27.65,1.9c.13.39.28.77.4,1.16.22.7.39,1.41.59,2.11s.46,1.57.66,2.36c.07.27.16.54.23.81.14.57.22,1.13.35,1.7.28,1.23.54,2.46.76,3.69.06.33.15.67.21,1,.12.77.2,1.54.3,2.3.07.55.16,1.1.22,1.65.18,1.72.32,3.43.37,5.12.44,14.62-4.38,25.08-12.55,30.2l-172.35,105c8.17-5.12,13-15.58,12.55-30.2,0-1.69-.19-3.41-.38-5.13C1091.66,1996.83,1091.57,1996.28,1091.5,1995.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M1043.21,1924c-26.09-13.93-46.54-1.39-45.65,28.06s22.78,64.61,48.87,78.54,46.55,1.36,45.66-28.06S1069.33,1937.9,1043.21,1924Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/empty_table.723ebbd16bbe90281963f4465add927e.svg";
export { ForwardRef as ReactComponent };